<template>
  <div class="text-center ma-2">
    <v-snackbar :value="snackbar" @input="onClose" :color="color">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Snackbars",
  props: ["text", "snackbar", "color"],
  data() {
    return {
      alert: true
    };
  },
  methods: {
    onClose() {
      this.$emit("closeSnackbar");
    }
  }
};
</script>
